<template>
<b-container fluid class="theme-red">
       <div class="page-header">
          <Navbar text=""/>
        </div>

        <div class="card">
          <div class="card-body">
            <h2 v-if=isSuccess class="card-title">Payment was successful. We are processing your request and in few seconds everything should be ready.</h2>
            <h2 v-if=!isSuccess class="card-title">Payment failed. Please contact with our support for more information.</h2>
          </div>
        </div>
    </b-container>
</template>


<script>
import Navbar from "../Navigation/Navbar"
import { setTimeout } from 'timers';
export default {
    name: 'PaymentResult',
    components: {
        Navbar
    },
    data () {
        return {
            isSuccess: true
        }
    },
    created() {
        this.isSuccess = this.$route.params.status == "success" ? true : false;
        if (this.isSuccess)
            this.$cookie.set('payment', 'success', {expires: '2m'});
    },
    mounted() {
        setTimeout ( () => this.$router.push({name: "Subscription"}), 10000);
    }
}
</script> 